import script from "./ProxyForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProxyForm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__